export class EntityHelper {
  static compareObjects<T>(a: T, b: T, excludeEmpty = true): boolean {
    let srcA: T;
    let srcB: T;

    [srcA, srcB] = [a, b];

    if (excludeEmpty) {
      [srcA, srcB] = [a, b].map(state =>
        Object.entries(state).reduce((p, [key, value]) => (value ? { ...p, [key]: value } : p), {} as T)
      );
    }

    return JSON.stringify(srcA) == JSON.stringify(srcB);
  }
}
